export interface Testimonial {
  text: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    text: 'I teach 30 lessons a week at our riding school and my evenings used to disappear into lesson planning. Now I open the lesson plan system, choose the objective, and walk into the arena with the exercises, arena setup and progressions already there. The rider assessment sheets changed how I start with a new client — I know exactly what to work on instead of improvising in the first ten minutes.',
    author: 'Caroline Hartley',
    role: 'BHS Accredited Instructor, 47',
    location: 'Gloucestershire, United Kingdom',
  },
  {
    text: 'The exercise library is worth the whole price on its own. Position, balance, steering, transitions — everything organized with setup, cues, common errors and corrections written out. Mid-lesson I can switch to a regression without losing the flow, and my nervous adult riders have progressed more this season than in the previous two.',
    author: 'Megan Dawson',
    role: 'Riding School Head Coach, 39',
    location: 'Calgary, Canada',
  },
  {
    text: 'I have been teaching for 26 years, so I was sceptical about another digital product. This is not theory — it is the paperwork and structure I always meant to build for myself and never finished. The arena setup cards get printed and laminated, and my working pupil can now prepare the arena before I even arrive.',
    author: 'Robert Kensington',
    role: 'Equestrian Centre Owner & Instructor, 58',
    location: 'Scottsdale, United States',
  },
  {
    text: 'Group lessons were my weak point. Six riders, six different levels, one arena. The private and group management toolkit gave me arena flow, mixed-level adaptations and observation rotations that actually work. Parents have commented on how organized the sessions feel, and my group bookings are full for the first time.',
    author: 'Lucy Fairbanks',
    role: 'Pony Club Instructor, 34',
    location: 'Melbourne, Australia',
  },
  {
    text: 'Follow-up was where I lost riders. I would teach a great lesson and then forget what we worked on three weeks later. The rider records, progress trackers and next-lesson planners fixed that completely. Riders can see their development written down, and that keeps them rebooking their blocks of lessons.',
    author: 'Fiona MacLeod',
    role: 'Freelance Riding Instructor, 44',
    location: 'Perthshire, United Kingdom',
  },
]
